import React from 'react'
import SyncIcon from 'src/app/assets/icons/ico-sync-alt.svg'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useSoundEffect } from 'src/hooks/useSoundEffect'
import { FloatingButtonCircles } from 'src/components/FloatingButtonCircles'

type Props = Readonly<{
  isEnabled: boolean
  isActive: boolean
  onToggle: () => void
}>

export function AutoBetSwitch({ isActive, isEnabled, onToggle }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const { playEffect } = useSoundEffect()

  const handleToggle = () => {
    playEffect('click')
    onToggle()
  }

  const buttonClasses = `btn btn-auto-enable ${isEnabled ? 'active' : ''} ${
    isActive ? 'betting' : ''
  }`

  return (
    <button className={buttonClasses} onClick={handleToggle} type="button">
      <div className="icon">
        <SyncIcon />
      </div>
      <span className="label">{t('Auto Bet')}</span>
      <FloatingButtonCircles variant={isEnabled ? 'green' : 'default'} />
    </button>
  )
}
